SingleColumn.propTypes = {
    
};

SingleColumn.defaultProps = {};

export default function SingleColumn({children}) {
    return children;
};